export class AnonymousTokenNotAllowedError extends Error {}
